module.exports = __webpack_public_path__ + "static/media/restaurant-10.487bebae.jpg";